<template>
  <div class="oDetailApp" :style="'min-height:'+curHeight+'px'" v-loading.fullscreen.lock="fullscreenLoading" element-loading-text="数据加载中" element-loading-background="rgba(0, 0, 0, 0)" element-loading-spinner="el-icon-loading">

    <dl v-if="orderNumber ==''">
      <dd v-for="(item,i) in b" @click="showTo(item.id)">
        <span>购买人:{{item.name}}</span>
        <span>销售价:￥{{item.price}}</span>
        <span>订单编号:{{item.number}}</span>
        <b>立即选择</b>
      </dd>

      <dt @click="toPush(id,'scenicDetail')" v-if="b.length <= 0">
        <img class="noneData" src="~assets/images/no.png" />
        <p>立即购买</p>
      </dt>
    </dl>

    <div v-if="orderNumber !=''">
      <div class="chooseUser" v-if="attest.length <= 0" @click="go">
        <div class="leftuser">
          <p>选择人员</p>
        </div>
        <img src="~assets/images/me_jiantou.png" />
      </div>
      <div class="chooseUser" v-if="attest.length > 0">
        <div class="leftuser" @click="drawer = true">
          <p>{{name}}</p>
          <p class="curt" v-if="idCard !=''">{{idCard}}</p>
        </div>
        <img src="~assets/images/me_jiantou.png" />
      </div>

    <div class="scenic">
      <div class="top">
        <img class="left" :src="baseUrl+scenic.img" >
        <div class="right">
          <span class="curt">{{scenic.title}}</span>
          <span style="overflow: hidden;text-overflow:ellipsis;white-space: nowrap;">{{scenic.address}}</span>
          <div class="bottom">空间卡剩余：{{total}}张可用</div>
        </div>
      </div>
    </div>

    <div class="back" @click="back"><img src="~assets/images/back.png" /></div>

    <div class="orderInfo" v-if="order!=null">
      <!--<div class="orderSn" style="color:#f00">状态：{{order.status == 2 ? '已支付' : '已完成'}}</div>-->
      <div class="orderSn">金额：
        <span><i>￥</i><b>{{order.price.split(".")[0]}}</b>
            <i>.{{order.price.split(".")[1]}}</i></span>
        <font>{{order.status == 2 ? '已支付' : '已完成'}}</font>
      </div>
      <div class="orderSn gaa">订单编号：{{order.number}}</div>
      <div class="orderSn gaa">下单时间：{{order.paytime}}</div>
    </div>

    <button v-if="total>0" class="btn" @click="saveLock">我要入住</button>
    </div>

    <el-dialog title="恭喜您！成功抵扣一张入住卡" :visible.sync="dialogFormVisible" :close-on-click-modal="false">
      <div v-if="scenic.id != 10">
        <img id="avatar" :src="userData.avatar" />
        <div id="username">{{userData.username}}</div>
        <div class="c55">
        <div id="username">入住时间：{{timer}}</div>
        <div id="username">已使用空间卡  {{yymb}}张，剩余空间卡<font>{{total}}</font>张</div>
        </div>
        <!--<div class="gggg">抵扣入园卷成功，请您进园游览！</div>-->
        <div style="text-align:center;padding-top:20px;padding-bottom:25px;color:#f00;font-weight:bold;font-size:16px">{{djstimer}}</div>
      </div>
    </el-dialog>


    <el-drawer
      title="选择人员" :visible.sync="drawer" :direction="direction" size="50%" :withHeader="true">
      <ul>
        <li v-for="(item,i) in attest" @click="choose(i)">
          <p>{{item.name}}</p>
          <p>{{item.card}}</p>
          <a v-if="i==active"><img src="~assets/images/choose2.png" /></a>
          <a v-if="i!=active"><img src="~assets/images/choose1.png" /></a>
        </li>
      </ul>
    </el-drawer>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        curHeight:0,
        fullscreenLoading: false,
        userData:[],
        scenic:[],
        total:0,
        order:[],
        baseUrl:'',
        phone:'',
        name:'选择人员',
        idCard:'',
        dialogFormVisible: false,
        timer:'',
        yymb:0,
        orderNumber:'',
        b:[],
        djstimer:0,
        drawer:false,
        direction: 'btt',
        attest:[],
        active:-1,
        id:0
      };
    },
    beforeMount() {
      this.baseUrl = this.$host;
      if(localStorage.getItem('userjwt') == null){
        var code = this.codefun('code');
        if(!code){
          var id = this.$route.query.id;
          var url = encodeURIComponent('http://user.4008005216.com/main/oDetail?id='+id);
          window.location.href = "https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxa89a20966e69c2a5&redirect_uri="+url+"&response_type=code&scope=snsapi_userinfo&state=STATE";
          return;
        }else{
          this.code = code;
        }
      }else{
        this.userData = JSON.parse(localStorage.getItem('userjwt'));
      }
    },
    mounted() {
      var id = this.$route.query.id;
      this.id = id;
      this.beforeMount();
      if(localStorage.getItem('userjwt') == null){
        this.login();
      }else{
        this.timers();
        this.getBgg();
        this.attest1();
      }
    },

    methods: {
      beforeMount:function(){
        var h = document.documentElement.clientHeight || document.body.clientHeight;
        this.curHeight =h; //减去页面上固定高度height
      },
      toPush:function(index,url){
        this.$router.push({
          path:url,
          query:{
            id:index
          }
        })
      },

      choose:function(n){
        this.active = n;
        this.idCard = this.attest[n].card;
        this.name = this.attest[n].name;
        this.drawer = false;
      },

      back:function(){
        this.orderNumber = ''
      },

      attest1:function(){
        var that = this;
        that.fullscreenLoading = true
        this.axios({
          method:'post',
          url:that.$host+'home/user/attest',
          params:{
            user_id:that.userData.id
          }
        }).then(function(response){
          var res = response.data.data;
          that.attest = res.rs;
          that.phone = res.phone.phone;
          that.fullscreenLoading = false;
        }).catch(err=>{
          that.fullscreenLoading = false
        });
      },

      go:function(){
        window.location.href="http://user.4008005216.com/main/attest"
      },

      saveLock:function(){
        var that = this;
        if(that.idCard == ''){
          alert('请选择人员');
          return false;
        }
        that.fullscreenLoading = true;
        that.axios({
          'url': that.$host+'home/lock/lockSave',
          'method': 'post',
          params:{
            user_id:that.userData.id,
            idCard:that.idCard,
            name:that.name,
            order_id:that.order.id,
            card_id:that.order.card_id,
            num:1,
            lock_id:that.scenic.id,
            number:that.order.number
          }
        }).then(function(response){
          that.fullscreenLoading = false;
          var res = response.data.data
          if(response.data.status == 200){
            that.dialogFormVisible = true
            that.getScenic(that.orderNumber);
            that.timer = res.timer;
          }else{
            alert(response.data.message);
          }
        }).catch(err=>{
          console.log('请求失败:'+err);
        });
      },
      showTo:function(id){
        this.orderNumber = id;
        this.getScenic(id)
      },

      getScenic:function(order_id){
        var id = this.$route.query.id;
        var that = this;
        that.axios({
          'url': that.$host+'home/lock/lockCard',
          'method': 'post',
          params:{
            user_id:that.userData.id,
            lock_id:id,
            order_id:order_id
          }
        }).then(function(response){
          var res = response.data.data;

          that.scenic = res.lock;
          that.total = res.total;
          that.yymb = res.yymb;
          that.order = res.order;

          that.fullscreenLoading = false;
        }).catch(err=>{
          console.log('请求失败:'+err);
          that.fullscreenLoading = false;
        });
      },
      //查询空间卡个人订单
      getBgg:function(){
        var that = this;
        that.axios({
          'url': that.$host+'home/lock/lockUserOrder',
          'method': 'post',
          params:{
            user_id:that.userData.id
          }
        }).then(function(response){
          var res = response.data.data;
          that.b = res

          that.fullscreenLoading = false;
        }).catch(err=>{
          console.log('请求失败:'+err);
          that.fullscreenLoading = false;
        });
      },

      login:function(){
        var that = this;
        that.axios({
          method:'post',
          url:that.$host+'home/user/login',
          params:{
            code:that.code
          }
        }).then(function(response){
          var res = response.data;
          that.userData = res.data;
          localStorage.setItem('userjwt', JSON.stringify(res.data));
        }).catch(err=>{

        });
      },
      codefun:function(name) {
        let reg = new RegExp("(\\?|&)" + name + "=([^&]*)(&|$)", "i");
        let r = window.location.search.match(reg);
        if (r != null) return unescape(r[2]);
        return false;
      },
      timers:function(){
        var that = this;
        setInterval(function(){
            var date=new Date();
            var year=date.getFullYear();
            var month=date.getMonth()+1;
            var day=date.getDate();
            
            var hour=date.getHours();
            that.turnDate(hour);
            var min=date.getMinutes();
            that.turnDate(min);
            var sec=date.getSeconds();
            sec=that.turnDate(sec);
            that.djstimer=year+"年"+month+"月"+day+"日 "+hour+":"+min+":"+sec;
        },1000)
      },
      turnDate:function(date){
          if(date<10){
              return date="0"+date
          }else{
              return date
          }
      }
    }
  };
</script>

<style>
  .el-loading-spinner{
    width:30%;
    background:rgba(0,0,0,0.8);
    left:50%;
    transform: translateX(-50%);
    border-radius:5px;
    padding:15px 0;
    color:#fff;
  }
  .el-loading-spinner i{
    color:#fff;
    font-size:22px
  }
  .el-loading-spinner .el-loading-text{
    color:#fff;
  }
  .el-message-box{
    width:70%
  }
  .el-dialog{
    width:80% !important;
  }
  .el-dialog__body{
    padding:20px 20px 0 20px !important;
  }
  .el-form-item__content{
    margin-left:0 !important
  }
  .el-form-item__label{
    text-align:left
  }
  .oDetailApp{
    max-width:640px;
    background:#f7faff;
    margin:0 auto;
    padding-top:15px;
  }

  .oDetailApp .scenic{
    display:block;
    width:94%;
    margin:15px auto 15px auto;
    background: #FFFFFF;
    box-shadow: 0px 0px 10px 0px rgba(47, 120, 255, 0.2);
    border-radius: 10px;
    padding:0 0 15px 0
  }
  .oDetailApp .scenic a{
    display:block;
    color:#2F78FF;
    border: 1px solid #2F78FF;
    border-radius: 30px;
    width: 83px;
    height: 30px;
    text-align:center;
    line-height:30px;
    font-weight: 600;
    font-size:14px;
    margin:15px 15px 0 auto;
  }
  .oDetailApp .scenic .top:after{
    content: '';
    height: 0;
    line-height: 0;
    display: block;
    visibility: hidden;
    clear: both;
  }
  .oDetailApp .scenic .left{
    float:left;
    width:30%;
    border-radius:5px;
    margin:3% 0 0 3%
  }
  .oDetailApp .scenic .right{
    float:left;
    width:60%;
    margin:3% 0 0 2%
  }
  .oDetailApp .scenic .right span{
    display:block;
    font-size:14px;
    letter-spacing:1px;
    padding-bottom:10px;
    color:#666;
  }
  .oDetailApp .scenic .right span font{
    padding-left:20px;
  }
  .oDetailApp .scenic .right span.curt{
    font-weight:bold;
    font-size:15px;
  }

  .oDetailApp .scenic .right .bottom{
    color:#007aff;
    letter-spacing:1px;
    background: #EBF2FF;
    border-radius: 5px;
    display:inline-block;
    color: #2F78FF;
    font-size:14px;
    padding:4px 20px;
  }

  .oDetailApp .orderInfo{
    display:block;
    width:94%;
    background:#fff;
    margin:0 auto 10px auto;
    border-radius:5px;
    height:150px;
    box-shadow: 0px 0px 10px 0px rgba(47, 120, 255, 0.2);
    border-radius: 10px;
  }
  .oDetailApp .orderInfo .orderSn{
    padding:4% 0 0 3%;
    font-size:15px;
    letter-spacing:1px;
    font-weight:bold;
  }
  .oDetailApp .orderInfo .gaa{
    font-size: 15px;
    font-family: PingFang SC;
    font-weight: bold;
    color: #666666;
    padding:6% 0 0 3%;
  }
  .oDetailApp .orderInfo .orderSn font{
    float:right;
    margin-right:15px;
    color:#0FB144
  }

  .oDetailApp .orderInfo .orderSn span b{
    color: #FF6600;
    font-size:17px;
    font-weight:600;
  }

  .oDetailApp .orderInfo .orderSn span i{
    color: #FF6600;
    font-size:12px;
    font-style:normal
  }


  .oDetailApp .btn{
    display:block;
    width:84%;
    background:#007aff;
    margin:0 auto;
    border-radius:45px;
    height:45px;
    border:none;
    color:#fff;
    letter-spacing:1px;
    font-size:16px;
    font-weight:bold;
    margin-top:35px;
  }
  .gggg{
    color:red;;
    font-size:18px;
    padding-bottom:35px;
    text-align:center;
  }
  #avatar{
    border-radius:50%;
    width:80px;
    display:block;
    margin:0 auto
  }
  #username{
    text-align:center;
    font-size:18px;
    color:#000;
    padding:10px 0
  }
  .c55{
    width:98%;
    display:block;
    margin:0 auto;
    background: #F7FAFF;
    border-radius: 10px;
  }
  .c55 #username{
    color:#666;
    font-size:15px;
  }
  .c55 #username font{
    color:#2F78FF
  }

  .oDetailApp dd{
    width:92%;
    background: #FFFFFF;
    box-shadow: 0px 0px 10px 0px rgba(47, 120, 255, 0.2);
    border-radius: 10px;
    display:block;
    margin:0 auto;
    margin-bottom:15px;
    position:relative;
    padding:8px 0;
  }
  .oDetailApp dd span{
    display:block;
    padding:10px 20px;
    font-size:15px;
    letter-spacing:1px;
  }
  .oDetailApp dd b{
    position:absolute;
    right:15px;
    top:15px;
    color:#FF6600;
    font-size:15px;
    border: 1px solid #FF6600;
    border-radius: 25px;
    width: 90px;
    height: 30px;
    text-align:center;
    line-height: 30px;
  }

  .oDetailApp dt{
    position:relative
  }
  .oDetailApp dt img{
    display:block;
    width:100%;
  }
  .oDetailApp dt p{
    position:absolute;
    left:63%;
    transform: translateX(-63%);
    top:70.5%;
    transform: translateY(-70%);
    color:#f00;
    font-weight:bold;
    font-size:15px;
  }




  .oDetailApp .chooseUser{
    width:94%;
    display:block;
    margin:0 auto;
    background:#fff;
    box-shadow: 0px 0px 10px 0px rgba(47, 120, 255, 0.2);
    border-radius: 10px;
    padding:20px 0;
    position:relative;
  }
  .oDetailApp .chooseUser:after{
    display:block;clear:both;content:"";visibility:hidden;height:0
  }
  .oDetailApp .chooseUser .leftuser{
    float:left;
    width:80%;
    margin-left:15px;
  }
  .oDetailApp .chooseUser .leftuser p{
    color:#333;
    font-size:15px;
  }
  .oDetailApp .chooseUser .leftuser p.curt{
    padding-top:10px;
    color:#666
  }
  .oDetailApp .chooseUser img{
    width:8px;
    position:absolute;
    top:51%;
    transform: translateY(-50%);
    right:15px;
  }
  .oDetailApp .el-dialog__header{
    text-align:center;
  }
  .oDetailApp .el-dialog__title{
    font-weight: bold;
    color: #0FB144;
    
  }
  .oDetailApp .el-dialog__headerbtn{
    display:none;
  } 
  .oDetailApp #el-drawer__title span{
    text-align:center;
    font-size: 18px;
    font-family: PingFang SC;
    font-weight: 600;
    color: #2F78FF;
  }

  .oDetailApp .el-drawer__wrapper ul{
    width:90%;
    margin:0 auto;
  }
  .oDetailApp .el-drawer__wrapper li{
    border-bottom:solid 1px #EBF2FF;
    padding:15px 0 10px 0;
    position:relative;
  }
  .oDetailApp .el-drawer__wrapper li:last-child{
    border-bottom:none;
  }

  .oDetailApp .el-drawer__wrapper li p{
    padding-bottom:10px;
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #333333;
    padding-left:45px;
  }
  .oDetailApp .el-drawer__wrapper li p:last-child{
    color: #666;
  }

  .oDetailApp .el-drawer__wrapper li a{
    position:absolute;
    left:0;
    top:50%;
    transform: translateY(-50%);
    color: #2F78FF;
    font-size:18px;
  }
  .oDetailApp .el-drawer__wrapper li a img{
    display:block;
    width:30px;
  }

  .oDetailApp .back{
    position:fixed;
    left:10px;
    bottom:10%;
  }
  .oDetailApp .back img{
    display:block;
    width:50px;
  }

  .oDetailApp .jbht{
    border:4px dashed #ffd700;
    padding-top:15px;
    position:relative;
    bottom:15px;
    border-radius: 6px;
  }
  .oDetailApp .jbht span{
    position:absolute;
    top:-15px;
    right:-15px;
    color:#f00;
    font-weight:bold;
    border:4px dashed #ffd700;
    border-radius: 50%;
    width:30px;
    height:30px;
    background:#fff;
    font-size:15px;
    line-height:30px;
    text-align:center
  }
</style>